@if (props) {
  <div id="inpopup" class="overlay">
    <div class="popup">
      <h2>{{props.title}}</h2>
      @if (props.type !== 'LOADING') {
        <a class="close" href="javascript:;" (click)="closePopup()">&times;</a>
      }
      <div class="content">
        {{ props.text }}
        @if (props.type === 'LOADING') {
          <span class="spinner-border" role="status"></span>
        }
        @if (props.type === 'LOADING') {
          <span class="sr-only">Loading...</span>
        }
      </div>
      @if (props.type !== 'LOADING') {
        <div class="countdown-circle">
          <circle-progress
            [percent]="percentage"
            [radius]="16"
            [outerStrokeWidth]="4"
            [outerStrokeColor]="primaryColor"
            [animation]="false"
          ></circle-progress>
        </div>
      }
    </div>
  </div>
}